<script>
    import R, {LOADER} from "../lib/requests";
    import {API_URL, ROUTE_TYPES, ROUTE_TYPE, PAYMENT_TYPES} from "../lib/constants";
    import app from '../stores/app';
    import {formatDate, lastDateOfMonth, sort} from "../lib/lib";
    import Notifier from "../stores/notifier";
    import PageHeader from "../components/PageHeader.svelte";
    import DateControl from "../components/controls/DateControl.svelte";
    import MultiSelectControl from "../components/controls/MultiSelectControl.svelte";

    export let accounts = null;
    export let transporters = null;

    const pageHeaderControls = [
        {id: 'export', name: 'EXPORT', icon: 'file-excel'},
    ];

    let report = null;
    let routeTypes = [];
    let allVehicles = [];
    let vehicleTypes = [];
    let vehicles = [];
    let drivers = [];
    let search = {
        date_from: null,
        date_to: null,
        account_id: '',
        transporter_id: '',
        vehicle_type_id: '',
        vehicle_id: '',
        driver_id: '',
        route_type: [],
    }

    let paymentTypeTransfers = null;
    let selectedPaymentType = null;

    const initialize = () => {
        // init transfer types
        Object.keys(ROUTE_TYPE).map(key => {
            routeTypes.push({
                id: ROUTE_TYPE[key],
                name: ROUTE_TYPES[ROUTE_TYPE[key]],
                is_checked: 1,
            });
            search.route_type.push(ROUTE_TYPE[key]);
        });

        // load vehicles
        loadVehicles();
    }

    const loadVehicles = () => {
        const onSuccess = result => {
            allVehicles = result;
        }

        const onFailure = err => {
        };

        // use "search" instead of "index" in order to get drivers on each vehicle
        R.handle(R.vehicle.search, [], onSuccess, onFailure, LOADER.PAGE);
    }

    const onDateFromChange = () => {
        if (!search.date_from) {
            return;
        }

        if (!search.date_to || search.date_to < search.date_from) {
            search.date_to = lastDateOfMonth(search.date_from);
        }
    }

    const onTransporterChange = () => {
        search.vehicle_type_id = '';
        search.vehicle_id = '';
        search.driver_id = '';

        vehicleTypes = [];
        vehicles = [];
        drivers = [];

        let arr = allVehicles.filter(x => x.transporter_id == search.transporter_id);
        arr.map(item => {
            // set transporter vehicle
            vehicles.push({
                id: item.id,
                licence_no: item.licence_no,
                type_id: item.type.id
            });

            // set transporter driver
            item.drivers.map(driver => {
                drivers.push({
                    id: driver.id,
                    name: driver.name
                });
            });

            // set transporter vehicle types
            let vType = $app.vehicle_types.find(x => x.id == item.type.id);
            if (vType) {
                vehicleTypes.push({
                    id: vType.id,
                    name: vType.name,
                });
            }
        });

        // get unique values
        vehicleTypes = sort(vehicleTypes.filter((item, pos, self) => self.findIndex(v => v.id === item.id) === pos), 'name');
        vehicles = sort(vehicles.filter((item, pos, self) => self.findIndex(v => v.id === item.id) === pos), 'licence_no');
        drivers = sort(drivers.filter((item, pos, self) => self.findIndex(v => v.id === item.id) === pos), 'name');
    }

    const onVehicleTypeChange = () => {
        search.vehicle_id = '';
        search.driver_id = '';
    }

    const onVehicleChange = () => {
        search.driver_id = '';
        drivers = [];
        let vehicle = allVehicles.find(x => x.id == search.vehicle_id);
        if (vehicle) {
            drivers = vehicle.drivers;
        }
    }

    // Display payment type transfers
    const togglePaymentTypeTransfers = pt => {
        if (pt == selectedPaymentType) {
            selectedPaymentType = null;
            paymentTypeTransfers = null;
            return;
        }

        selectedPaymentType = pt;
        paymentTypeTransfers = report.totals[pt].transfers;
    }


    const validate = () => {
        let error = null;

        if (!search.transporter_id) {
            error = "Select transporter for the report!";
        }

        if (!search.account_id) {
            error = "Select account for the report!";
        }

        if (!search.date_from || !search.date_to) {
            error = "Select dates for the report!";
        }

        if (error) {
            Notifier.showError(error);
            return false;
        }

        return true;
    }

    const load = () => {
        const onSuccess = result => {
            report = result;
            selectedPaymentType = null
            paymentTypeTransfers = null;
        }

        const onFailure = err => {
        };

        if (!validate()) {
            return;
        }

        R.handle(R.report.absorption, search, onSuccess, onFailure, LOADER.POPUP);
    }

    const onExport = () => {
        if (!validate()) {
            return;
        }

        // console.log(API_URL + '/export.php' + extra);
        const extra = `?report=absorption&` + new URLSearchParams(search);
        window.open(API_URL + '/export.php' + extra);
    }

    initialize();
</script>
<PageHeader title="Absorption Report" controls={ pageHeaderControls } on:export={ onExport }/>

{#if accounts}
    <div class="panel-simple p-2 mb-4">
        <div class="row">
            <div class="col-lg-3 col-md-6 mb-2">
                <div class="row">
                    <div class="col-6">
                        <DateControl bind:value="{ search.date_from }" placeholder="from"
                                     on:change={ onDateFromChange }/>
                    </div>
                    <div class="col-6">
                        <DateControl bind:value="{ search.date_to }" placeholder="to"/>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-12 mb-2">
                <select class="form-select" bind:value="{ search.account_id }">
                    <option value="">account</option>
                    {#each accounts as item}
                        <option value="{ item.id }">{ item.name }</option>
                    {/each}
                </select>
            </div>
            <div class="col-lg-3 col-md-6 col-12 mb-2">
                <select class="form-select" bind:value="{ search.transporter_id }" on:change={ onTransporterChange }>
                    <option value="">transporter</option>
                    {#each transporters as item}
                        <option value="{ item.id }">{ item.name }</option>
                    {/each}
                </select>
            </div>
            <div class="col-lg-3 col-md-6 col-12 mb-2">
                <select class="form-select" bind:value="{ search.vehicle_type_id }" on:change={ onVehicleTypeChange }>
                    <option value="">vehicle type</option>
                    <!--{#each vehicleTypes as item}-->
                    <!--    <option value="{ item.id }">{ item.name }</option>-->
                    <!--    {/each}-->
                    {#each $app.vehicle_types as item}
                        <option value="{ item.id }">{ item.name }</option>
                    {/each}
                </select>
            </div>
            <div class="col-lg-3 col-md-6 col-12 mb-2-md mb-2-sm mb-2-xs">
                <select class="form-select" bind:value="{ search.vehicle_id }" on:change={ onVehicleChange }>
                    <option value="">vehicle</option>
                    {#each vehicles as item}
                        {#if !search.vehicle_type_id || search.vehicle_type_id == item.type_id}
                            <option value="{ item.id }">{ item.licence_no }</option>
                        {/if}
                    {/each}
                </select>
            </div>
            <div class="col-lg-3 col-md-6 col-12 mb-2-md mb-2-xs">
                <select class="form-select" bind:value="{ search.driver_id }">
                    <option value="">driver</option>
                    {#each drivers as item}
                        <option value="{ item.id }">{ item.name }</option>
                    {/each}
                </select>
            </div>
            <div class="col-lg-3 col-md-6 col-12 mb-2-xs">
                <MultiSelectControl options="{ routeTypes }" bind:value="{ search.route_type }"
                                    placeholder="route type"/>
            </div>
            <div class="col-lg-3 col-md-6 col-12">
                <button class="btn btn-primary btn-block" on:click={ load }>REPORT</button>
            </div>
        </div>
    </div>
{/if}

{#if report}
    <div class="row">
        <div class="col-lg-4">
            <table class="table table-report table-bordered mb-5">
                <thead>
                <tr>
                    <th colspan="2">
                        Period: <b>{ report.period }</b><br>
                        Account: <b>{ report.account }</b><br>
                        Transporter: <b>{ report.transporter }</b><br>
                        {#if report.vehicle_type}
                            Vehicle Type: <b>{ report.vehicle_type }</b><br>
                        {/if}
                        {#if report.vehicle}
                            Plate: <b>{ report.vehicle }</b><br>
                        {/if}
                        {#if report.driver}
                            Driver: <b>{ report.driver }</b><br>
                        {/if}
                        Type: <b>{ report.route_type }</b><br>
                        Type Total: <b>{ report.total_route_type }</b>
                    </th>
                </tr>
                </thead>
                <tbody>
                {#each report.payment_types as pt}
                    <tr class="row-separator borderless">
                        <td colspan="2"></td>
                    </tr>
                    <tr>
                        <td>
                            <div class="is-link fw-bold" on:click={ () => togglePaymentTypeTransfers(pt) }>Transfers
                            </div>
                        </td>
                        <td class="text-end">{ report.totals[pt].total_transfers }</td>
                    </tr>
                    <tr>
                        <td><b>Total { PAYMENT_TYPES[pt] } Gross</b></td>
                        <td class="price-column text-end">{ report.totals[pt].total_gross }</td>
                    </tr>
                    <tr>
                        <td><b>Total { PAYMENT_TYPES[pt] } Net</b></td>
                        <td class="text-end">{ report.totals[pt].total_net }</td>
                    </tr>
                    <tr>
                        <td><b>{ PAYMENT_TYPES[pt] } Gross</b></td>
                        <td class="text-end">{ report.totals[pt].total_transporter_gross }</td>
                    </tr>
                    <tr>
                        <td><b>{ PAYMENT_TYPES[pt] } Net</b></td>
                        <td class="text-end">{ report.totals[pt].total_transporter_net }</td>
                    </tr>
                    <tr>
                        <td><b>Transporter Gross</b></td>
                        <td class="text-end">{ report.totals[pt].transporter_gross }</td>
                    </tr>
                    <tr>
                        <td><b>Transporter Net</b></td>
                        <td class="text-end">{ report.totals[pt].transporter_net }</td>
                    </tr>
                    <tr>
                        <td><b>Commissions Gross</b></td>
                        <td class="text-end">{ report.totals[pt].commission_gross }</td>
                    </tr>
                    <tr>
                        <td><b>Commissions Net</b></td>
                        <td class="text-end">{ report.totals[pt].commission_net }</td>
                    </tr>
                    <tr>
                        <td><b>Absorption Index</b></td>
                        <td class="text-end">{ report.totals[pt].absorption }%</td>
                    </tr>
                {/each}
                </tbody>
            </table>
        </div>
        {#if paymentTypeTransfers != null}
            <div class="col-lg-8">
                <h5 class="mb-3">{ PAYMENT_TYPES[selectedPaymentType] } Transfers</h5>
                <div class="pt-transfers">
                    {#each paymentTypeTransfers as item}
                        <div class="pt-item">
                            <a href="/app/transfer/{ item.id }" class="is-link"
                               target="_blank">{ formatDate(item.transfer_at, 'd-m-y H:i') }</a>
                        </div>
                    {/each}
                </div>
            </div>
        {/if}
    </div>
{/if}

<style>
    .pt-transfers {
        display: flex;
        flex-wrap: wrap;
    }
    .pt-transfers .pt-item {
        background: #fff;
        padding: 5px 5px;
        margin: 1px;
    }
</style>